/**
 * Lead Profile Creation
 */
import React, { useEffect, useState } from "react";
import { IconButton, Tooltip, Button } from "@mui/material";
import {
  ArrowBackSharp as IconBack,
  Edit as IconEdit,
  CheckCircle as IconVerify,
  Person as IconAssign,
  Store as IconStoreVisit,
  Assignment as IconDocVerify,
  Forum as IconApprove,
  Verified as IconQualified,
  HowToReg as IconConverted,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import EditLeadProfile from "./EditLeadProfile";
import NewLeadProfile from "./NewLeadProfile";
import UiDialog from "components/Custom/UiDialog";
import HGraph from "components/Custom/HGraph";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import Btn from "components/Custom/Btn";
import Assign from "./Assign";

import { CRM_LEAD_STATUS, DEFAULTS, NOTIFY } from "common/config";
import { LABELS, SUCCESS } from "common/lables";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { CRM_APIs } from "apihandlers/crm";
import { COMMON_JS } from "common/scripts";
import { COLORS } from "common/colors";
import { GEO_APIs } from "apihandlers/geography";

interface defaultProps {}

const LeadProfile = (props: any) => {
  const { header, setDashMenu } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [manageNewDialog, setManageNewDialog] = useState<boolean>(false);
  const [manageEditDialog, setManageEditDialog] = useState<boolean>(false);
  const [manageAssignDialog, setManageAssignDialog] = useState<any>({});
  const [pieChart, setPieChart] = useState<any>({});
  const [columnChart, setColumnChart] = useState<any>({});
  const [rows, setRows] = useState<any[]>([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [areas, setAreas] = useState([]);

  const onAdd = () => {
    setManageNewDialog(!manageDialog);
    setSelectedRow({});
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageEditDialog(true);
  };

  const onVerify = async (row) => {
    const args = {
      crmLeadStatus: CRM_LEAD_STATUS.VERIFIED,
      activeStatus: "true",
      crmLeadId: row.id,
      crmLeadName: row.crmLeadName,
      isLeadVerified: "true",
    };
    const res = await CRM_APIs.manageCrmLeadProfile(args);
    if (res.status === 200) {
      COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
      getRows();
    } else {
      COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
    }
  };

  const onAssign = (row: any) => {
    setManageAssignDialog(row);
  };

  const onStoreVisit = (row: any) => {
    setSelectedRow(row);
    setManageEditDialog(true);
  };

  const onDocVerification = (row: any) => {
    setSelectedRow(row);
    setManageEditDialog(true);
  };

  const onApprovals = (row: any) => {
    setSelectedRow(row);
    setManageEditDialog(true);
  };

  const onConvert = (row: any) => {
    setSelectedRow(row);
    setManageEditDialog(true);
  };

  const [cols, setCols] = useState<any[]>([
    {
      key: "crmLeadName",
      name: "Lead Name",
      type: "number",
      width: "30%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "customerType",
      name: "Customer Type",
      type: "text",
      width: "20%",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "createdOn",
      name: "Created On",
      type: "text",
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "crmLeadStatus",
      name: "Lead Status",
      type: "dropdown",
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
      filters: [
        {
          id: CRM_LEAD_STATUS.NEW_LEAD,
          name: CRM_LEAD_STATUS.NEW_LEAD,
        },
        {
          id: CRM_LEAD_STATUS.VERIFIED,
          name: CRM_LEAD_STATUS.VERIFIED,
        },
        {
          id: CRM_LEAD_STATUS.ASSIGNED,
          name: CRM_LEAD_STATUS.ASSIGNED,
        },
        {
          id: CRM_LEAD_STATUS.STORE_VISIT,
          name: CRM_LEAD_STATUS.STORE_VISIT,
        },
        {
          id: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
          name: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
        },
        {
          id: CRM_LEAD_STATUS.APPROVALS,
          name: CRM_LEAD_STATUS.APPROVALS,
        },
        {
          id: CRM_LEAD_STATUS.QUALIFIED,
          name: CRM_LEAD_STATUS.QUALIFIED,
        },
        {
          id: CRM_LEAD_STATUS.CONVERTED,
          name: CRM_LEAD_STATUS.CONVERTED,
        },
        {
          id: CRM_LEAD_STATUS.CUSTOMER,
          name: CRM_LEAD_STATUS.CUSTOMER,
        },
      ],
    },
    {
      key: "options",
      name: "Options",
      type: "html",
      width: "20%",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        let editBtn = true;
        let verifyBtn = null;
        let assignBtn = null;
        let storeVisitBtn = null;
        let docBtn = null;
        let approvalBtn = null;
        let qualifiedBtn = null;
        let convertBtn = null;
        switch (row.crmLeadStatus) {
          case CRM_LEAD_STATUS.NEW_LEAD:
            verifyBtn = true;
            break;
          case CRM_LEAD_STATUS.VERIFIED:
            verifyBtn = false;
            assignBtn = true;
            break;
          case CRM_LEAD_STATUS.ASSIGNED:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = true;
            break;
          case CRM_LEAD_STATUS.STORE_VISIT:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = false;
            docBtn = true;
            break;
          case CRM_LEAD_STATUS.DOCUMENT_VERIFICATION:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = false;
            docBtn = false;
            approvalBtn = true;
            break;
          case CRM_LEAD_STATUS.APPROVALS:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = false;
            docBtn = false;
            approvalBtn = false;
            qualifiedBtn = true;
            break;
          case CRM_LEAD_STATUS.QUALIFIED:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = false;
            docBtn = false;
            approvalBtn = false;
            qualifiedBtn = false;
            convertBtn = true;
            break;
          case CRM_LEAD_STATUS.CONVERTED:
            verifyBtn = false;
            assignBtn = false;
            storeVisitBtn = false;
            docBtn = false;
            approvalBtn = false;
            qualifiedBtn = false;
            convertBtn = false;
            break;
          default:
            break;
        }
        return (
          <div className="options">
            {/* Edit => All */}
            {editBtn && (
              <Tooltip title={LABELS.EDIT} placement="bottom">
                <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
                  <IconEdit />
                </IconButton>
              </Tooltip>
            )}

            {/* Verify => If "New Lead" */}
            {verifyBtn !== null ? (
              verifyBtn ? (
                <Tooltip title={CRM_LEAD_STATUS.VERIFIED} placement="bottom">
                  <IconButton className="iconBtn" onClick={() => onVerify(row)}>
                    <IconVerify />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={CRM_LEAD_STATUS.VERIFIED} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconVerify />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {/* Assign => If "Verified" || "Assign" */}
            {assignBtn !== null ? (
              assignBtn ? (
                <Tooltip title={LABELS.ASSIGN} placement="bottom">
                  <IconButton className="iconBtn" onClick={() => onAssign(row)}>
                    <IconAssign />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={LABELS.ASSIGN} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconAssign />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {storeVisitBtn !== null ? (
              storeVisitBtn ? (
                <Tooltip title={LABELS.STORE_VISIT} placement="bottom">
                  <IconButton
                    className="iconBtn"
                    onClick={() => onStoreVisit(row)}
                  >
                    <IconStoreVisit />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={LABELS.STORE_VISIT} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconStoreVisit />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {docBtn !== null ? (
              docBtn ? (
                <Tooltip
                  title={CRM_LEAD_STATUS.DOCUMENT_VERIFICATION}
                  placement="bottom"
                >
                  <IconButton
                    className="iconBtn"
                    onClick={() => onDocVerification(row)}
                  >
                    <IconDocVerify />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  title={CRM_LEAD_STATUS.DOCUMENT_VERIFICATION}
                  placement="bottom"
                >
                  <IconButton className="iconBtn green" disableRipple>
                    <IconDocVerify />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {approvalBtn !== null ? (
              approvalBtn ? (
                <Tooltip title={CRM_LEAD_STATUS.APPROVALS} placement="bottom">
                  <IconButton
                    className="iconBtn"
                    onClick={() => onApprovals(row)}
                  >
                    <IconApprove />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={CRM_LEAD_STATUS.APPROVALS} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconApprove />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {qualifiedBtn !== null ? (
              qualifiedBtn ? (
                <Tooltip title={CRM_LEAD_STATUS.QUALIFIED} placement="bottom">
                  <IconButton
                    className="iconBtn"
                    onClick={() => onConvert(row)}
                  >
                    <IconQualified />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={CRM_LEAD_STATUS.QUALIFIED} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconQualified />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}

            {convertBtn !== null ? (
              convertBtn ? (
                <Tooltip title={CRM_LEAD_STATUS.CONVERTED} placement="bottom">
                  <IconButton
                    className="iconBtn"
                    onClick={() => onConvert(row)}
                  >
                    <IconConverted />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={CRM_LEAD_STATUS.CONVERTED} placement="bottom">
                  <IconButton className="iconBtn green" disableRipple>
                    <IconConverted />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <></>
            )}
          </div>
        );
      },
    },
  ]);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    try {
      const res: any = await GEO_APIs.getAreas({ activeStatus: "true" });
      const areaList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.areaName,
        };
      });
      setAreas(areaList);
      getRows();
    } catch (error) {}
  };

  const getRows = async () => {
    try {
      const args = {
        activeStatus: "true",
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      setRows(null);
      const res: any = await CUSTOMER_APIs.getCrmLeadProfiles(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        setRows(list);
      }
    } catch (error) {
      console.error("getUserTypes:", error);
    }
  };

  const gridHeight = window.innerHeight * 0.9;

  return (
    <React.Fragment>
      <div className="userDashboard">
        {header && (
          <div className="pageInfo">
            <ul className="breadcrumbs">
              <li
                onClick={() => {
                  setDashMenu(LABELS.HOME);
                }}
              >
                {LABELS.HOME}
              </li>
              <li className="dim">{" / "}</li>
              <li className="active">{LABELS.LEAD_PROFILE}</li>
            </ul>
            <h4>{LABELS.LEAD_PROFILE}</h4>
          </div>
        )}

        {pieChart.series && (
          <div className="graphs">
            <HGraph
              width={"50%"}
              type={"column"}
              xAxis={columnChart.xAxis}
              yAxis={columnChart.yAxis}
              title={" "}
              exportTitle={" "}
            />
            <HGraph
              width={"50%"}
              type={"pie"}
              float={"right"}
              series={pieChart.series}
              title={" "}
              exportTitle={" "}
            />
          </div>
        )}

        {manageEditDialog ? (
          <div className="flexColumn" style={{ width: "98%" }}>
            <div style={{ marginTop: 15 }}>
              <Btn
                startIcon={<IconBack />}
                text={LABELS.BACK}
                style={{ marginBottom: 15 }}
                onClick={() => {
                  setManageEditDialog(false);
                }}
              />
            </div>
            <EditLeadProfile
              selectedRow={selectedRow}
              areas={areas}
              onClose={() => {
                getRows();
                setManageEditDialog(false);
              }}
            />
          </div>
        ) : rows ? (
          <ExcelGrid
            height={gridHeight}
            cols={cols}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.LEAD_PROFILE}
            onAdd={onAdd}
            onReload={getRows}
          />
        ) : (
          <div className="pageCenter" style={{ height: gridHeight }}>
            <Loader />
          </div>
        )}

        {manageNewDialog && (
          <UiDialog
            open={true}
            title={LABELS.NEW_LEAD_PROFILE}
            size={"xl"}
            onClose={() => setManageNewDialog(false)}
          >
            <NewLeadProfile
              selectedRow={selectedRow}
              areas={areas}
              onClose={() => {
                setManageNewDialog(false);
                getRows();
              }}
            />
          </UiDialog>
        )}

        {manageAssignDialog.id && (
          <UiDialog
            open={true}
            title={LABELS.ASSIGN}
            size={"sm"}
            onClose={() => setManageAssignDialog({})}
          >
            <Assign
              data={manageAssignDialog}
              areas={areas}
              onClose={(loadRecs) => {
                setManageAssignDialog({});
                if (loadRecs) {
                  getRows();
                }
              }}
            />
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(LeadProfile);
